import { useSyncExternalStore } from 'react';

export function useScreenOrientation(): OrientationType {
  const orientation = useSyncExternalStore(
    subscribeOnScreenOrientationChange,
    getSnapshot,
  );
  return orientation;
}

export function subscribeOnScreenOrientationChange(
  callback: () => void,
): () => void {
  if ('orientation' in screen) {
    // Most browsers
    screen.orientation.addEventListener('change', callback);
    return () => screen.orientation.removeEventListener('change', callback);
  } else {
    // iOS <16.4
    window.addEventListener('orientationchange', callback);
    return () => window.removeEventListener('orientationchange', callback);
  }
}

function getSnapshot(): OrientationType {
  return 'orientation' in screen
    ? screen.orientation.type /* Most browsers */
    : mobileOrientationMap[window.orientation] /* iOS <16.4 */ ??
        'landscape-primary' /* Safari <16.4 */;
}

const mobileOrientationMap: Record<string, OrientationType> = {
  '0': 'portrait-primary',
  '90': 'landscape-primary',
  '180': 'portrait-secondary',
  '-90': 'landscape-secondary',
};
